export function PrimaryBadge() {
  return (
    <span
      className="rounded-full px-2 py-0.5 text-[10px] font-semibold"
      style={{ backgroundColor: 'var(--color-primary-soft)', color: 'var(--color-primary-strong)' }}
    >
      Principal
    </span>
  );
}
